// Central switch for which contact form the site renders.
//
//   static (default) - the presentational form. Renders nothing but markup and
//                      cannot fail. This is the safe state.
//   live             - the wired-up form: reCAPTCHA + POST to the Lambda.
//
// Flip it on by putting this in `.env` (and in the hosting console's build-time
// environment variables) alongside the two values below:
//
//   REACT_APP_CONTACT_FORM_LIVE=true
//
// These are inlined by Create React App at BUILD time, so restart `npm start`
// or rebuild after changing them.

export const SITE_KEY = process.env.REACT_APP_SITE_KEY;
export const API_URL = process.env.REACT_APP_API_URL;

const flag = String(process.env.REACT_APP_CONTACT_FORM_LIVE || '')
  .trim()
  .toLowerCase();

const liveFormRequested = flag === 'true' || flag === '1' || flag === 'yes';

// Both values must be present. Rendering the reCAPTCHA widget with an undefined
// sitekey throws during render, and an unhandled render error unmounts the whole
// React tree -- that white-screens every page, not just /contact. So a missing
// value forces the static form no matter what the flag says.
export const liveFormConfigured = Boolean(SITE_KEY && API_URL);

export const useLiveContactForm = liveFormRequested && liveFormConfigured;

if (liveFormRequested && !liveFormConfigured && process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  const missing = [!SITE_KEY && 'REACT_APP_SITE_KEY', !API_URL && 'REACT_APP_API_URL'].filter(
    Boolean
  );
  console.warn(
    `[contact form] REACT_APP_CONTACT_FORM_LIVE is on, but ${missing.join(' and ')} ` +
      `${missing.length > 1 ? 'are' : 'is'} missing. ` +
      'Falling back to the static form. See .env.example.'
  );
}
